import React, { createContext, useContext, useState, useMemo } from "react";
import { CONSTANTS } from "./data";

const defaultPaletteKey = CONSTANTS.DEFAULT_COLOR_PALETTE;
const palettes = CONSTANTS.COLOR_PALETTES;

export const PaletteContext = createContext({
  paletteKey: defaultPaletteKey,
  palette: palettes[defaultPaletteKey],
  setPaletteKey: (key: string) => {},
});

export function PaletteProvider({ children }: { children: React.ReactNode }) {
  const [paletteKey, setPaletteKey] = useState(defaultPaletteKey);

  const value = useMemo(
    () => ({
      paletteKey,
      palette: palettes[paletteKey],
      setPaletteKey,
    }),
    [paletteKey]
  );

  return (
    <PaletteContext.Provider value={value}>{children}</PaletteContext.Provider>
  );
}

export function usePalette() {
  return useContext(PaletteContext);
}
